import Commons from '../../../Services/Common/Common';

/**
 * 작업중지 알림/상세 (M_WOS_BASIC_03) 요청 파라미터 매핑
 * 사용처: M_WOS_BASIC_03_Query.js (useSearch1, useSearch2)
 */
export const WOS_BASIC_03_Schema = {
  mapper: {
    /** useSearch1 → GetWosBasicR2 (작업중지 상세 조회) SP_WOS_BASIC_R2 */
    search1: {
      WorkStopCd: (context) =>
        Commons.EncryptAES(context.workStopCd ?? '') || '',
    },
    /** useSearch2 → GetWosBasic03R1 (작업중지 여부 조회) SP_WOS_BASIC_R3 */
    search2: {
      UserId: (context) => context.userInfo?.userid ?? '',
      DepCd: (context) =>
        Commons.EncryptAES(context.userInfo?.depCd ?? '') || '',
    },
  },
};
